import { _virtel_schema_field_get } from "./ter-virtel-definition-lib";
import { sect } from "./virtel-consts";
// import { js_utils } from '../utils/js-utils.js';


// VIRT DEFINITIONS LIB FILEDS
// fields za sve virtele i bazu podataka

/*
TODO:

digitsafterdecimalpoint oznacava broj decimalnih mesta (digits after the decimal point have) i on cini deo size-a kod pojedinih tipova podataka.
na primer ako je size 7 a broj digitsafterdecimalpoint to znači ukupno 7 cifara ali od toga su tri nakon decimane tacke a 4 ispred. Decimalna tačka kod brojeva se ne racuna u size. Na primer 7654,321 je takav broj.
*/


const SECT_INSTANCE = sect.SECT_INSTANCE; //
const SECT_GENUS = sect.SECT_GENUS; //
const SECT_DB = sect.SECT_DB; //
const SECT_FRONTEND = sect.SECT_FRONTEND; //
const SECT_NESVRSTANI = sect.SECT_NESVRSTANI; //

/*
sect.SECT_HEADER = 'sect_header';
sect.SECT_INSTANCE = 'sect_instance'; // polja koja ne uticu na ident
sect.SECT_GENUS = 'sect_genus'; // polja koja uticu na genus tj. ident
sect.SECT_FIXED = 'sect_fixed'; // sect za fixed_fields
sect.SECT_DB = 'sect_db'; // polja koja se koriste samo u bazi podataka
sect.SECT_FRONTEND = 'sect_frontend'; // polja koja se koriste samo na formama u frontendu
sect.SECT_NESVRSTANI = 'sect_NESVRSTANI'; // za polja za koja nije jos odluceno
*/

/*
ZA SEMU I BAZU
field.size ce da bude length u bazi podataka
*/
export const TYPE_UNKNOWN_ = "STRING";
export const TYPE_STRING = "STRING";
export const TYPE_INTEGER = "INTEGER";
export const TYPE_FLOAT = "FLOAT";
export const TYPE_BOOL = "BOOL"; // po uzoru na https://reactjs.org/docs/typechecking-with-proptypes.html

/*
PROGRAM
moguca polja za program su sledeca
program: {
    default_tergrupa: "_bundle_eliminatorkapi",
    default_graphlevel: 3,
    frontend_only: true, // ne slati na backend i ignorisati na backendu
    use_classic_table: true, // jedan virtel ide u jednu tabelu.  usuprtonom se koristi par genus i instance
    use_genus: false, // ???
    use_autocreate: false // ???
}

NAPOMENA: i tipovi podataka koji se ne salju na backend moraju da imaju seme kako bi bilo pregledno i kako bi mogli da pristupamo njihovim karakteristikama iz pomocnih funkcija na jedinstven nacin.
*/

/*
fixed_fields je objekat koji sadrzi polja koja su uvek ista imaju uvek isti i key i value i ne moraj uda se unoase u forme i ne moraju da se cuvaju u bazi. Nakon ucitavanja iz baze ova polja treba da se automatski upisu u virtele.
*/


/*
NOVOSTI:
nova propertiji u definiciji filedova su primer, readme, opis/desc, path
default (default value za to polje d ase upisuje odmah pri primeni seme)

nova cesta polja su
_parent_subkey, _temid, 

*/

/*
sema podrzava skracenu sintaksu u sema.fields u kojoj umesto objecta moze da se stavi samo string sa nazivom polja (primer kod vrste pogona).

PRAVILA:
_c_ u nazivima šema oznacava da je taj virtel child od virtela napisanog sa leve strane od _c_.

polja koja pocinju sa flag_ su boolean mogu biti ili true ili false
polja koja pocinju sa multiflag_ su stringovi koji sluze da se detektuje vise tipova entitija koji idu u istu tabelu ali se mogu razlikovati prema toma koja polja se koriste.

*/


export const sorted_priority_virtel_fields_keys = [
  "virtelschemakey",
  "_draftelschemakey",
  "virtelclass",
  "flag_paired_with_smartel",
  "_tracking_key",
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  "bundle_id",
  "bomlevel",
  "graphlevel",
  "graphpath",
  "db_join_with_genus",
  "genus_ident",
  "db_instance_flag_standalone",
  "db_instance_flag_genus",
  "calculated_ident",
  "custom_ident",
  "kolicina",
  "kolicina_za_nalog",
  "jm",
  "terkategorija",
  "tergrupa",
  "teridentprefix",

  "flag_custom_pods_input",

  "terkknivo", // ???
  "bomlevel_imported", // NOVO 2023 April
  "multitranslator_lang", // NOVO 2023-10-22
  "virtel_note", // NOVO 2023-09-10
  "masa_po_jm", // NOVO 2024-04-23
  "flag_masa_po_jm_custom", // NOVO 2024-05-14
  "masa_po_jm_custom", // NOVO 2024-05-14
  "masa_kumulativno", // NOVO 2024-04-23
  "flag_cena_po_jm_custom", // NOVO 2024-11-14
  "cena_po_jm_custom", // NOVO 2024-11-14
  "cena_kumulativno", // NOVO 2024-11-14

  "virtel.virtel_program_sas_by_lang", // NOVO 2024-07-24
];


const _bool = {
  type: TYPE_BOOL,
  size: 1, //
};

const _ids = {
  type: TYPE_INTEGER,
  size: 12, // 11 je dovoljno za 10 milijardi integer ID-ova"
};

const _vreme_minute = {
  type: TYPE_INTEGER,
  size: 6, // 6 pre zareza je u minutama vise nego sto treba za ceo mesec vremena izrazen u minutama.
};

const _integer_mm = {
  type: TYPE_INTEGER,
  size: 8, // 8 pre zareza je u milimetrima dovoljno za duzinu od preko 10km.
};

const _float_mm = {
  type: TYPE_FLOAT,
  size: 12, // 8 pre zareza i 4 posle sto je u milimetrima dovoljno za duzinu od preko 10km pa do 10 hiljada manje velicine od milimetra
  digitsafterdecimalpoint: 4, //
};

const _float_ugao = {
  type: TYPE_FLOAT,
  size: 6, // 6 pre zareza i 3 posle sto je dovoljno za ugao od 360 stepeni i 1000 puta manji ugao od stepena.
  digitsafterdecimalpoint: 3, //
};

const _float_masa = {
  type: TYPE_FLOAT,
  size: 13, // 9 pre zareza i 4 posle sto je u gramima dovoljno za masu od preko 100 tona pa do 10 hiljada manje velicine od grama.
  digitsafterdecimalpoint: 4, //
};

const _float_cena = {
  type: TYPE_FLOAT,
  size: 15, // 13 pre zareza i 2 posle sto je u nekoj valuti dovoljno za cenu od preko 1000 milijardi pa do 100 puta manje velicine od jedinice valute.
  digitsafterdecimalpoint: 2, //
};

const _string64 = {
  type: TYPE_STRING,
  size: 64,
};

const _string100 = {
  type: TYPE_STRING,
  size: 100,
};

const _string200 = {
  type: TYPE_STRING,
  size: 200,
};

const _Par1_Par30 = {
  // name: "Par4",
  sect: SECT_INSTANCE,
  pods: {
    pods_own: true,
  },
  ..._string100
};






// readme: "Ovo je sema sa fieldovima koje sadrze prakticno svi virteli",
export const virtel_field_schema_lib = [

  // ---META NAJVAZNIJI
  {
    name: "rev_id",
    sect: SECT_DB,
    pods: {
      pods_meta: true,
    },
    ..._ids,
    readme: "ID REVIZIJE koji povezuje sve delove (virbom_members) od jednog virboma"
  },
  {
    name: "superkey",
    sect: SECT_DB,
    pods: {
      pods_meta: true,
    },
    ..._ids,
    readme: "ID SKUPA koji povezuje sve clanove jednog skupa."
  },
  {
    name: "subkey",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._ids,
    readme: ""
  },
  {
    name: "virtelschemakey",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string200,
    readme: "polje koje se ne upisuje u bazu ali koje govori sve o podacima kako da budu tretirani."
  },
  {
    name: "virtel_program_sas_by_lang",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._bool,
    readme: "polje koje govori da se sastavnica popunjava automatski na bazi lang tj. Par_jezik"
  },
  {
    name: "parent_subkey",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._ids,
  },
  {
    name: "flag_paired_with_smartel",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._bool,
    readme: "polje koje govori da li je ovaj virtel direktno uparen sa smartel.subkey"
  },
  {
    name: "bundle_id",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._ids,
    readme: "bundle_id sluzi da povezuje vise elemenata koji su zajedno vezani"
  },
  {
    name: "bomlevel",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    type: TYPE_STRING,
    size: 300,
    primer: "1.3.2.1.4",
    readme: "nivo kako se prikazuje u klasicnoj sastavnici"
  },
  {
    name: "bomlevel_imported",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    type: TYPE_STRING,
    size: 300,
    primer: "1.3.2.1.4",
    readme: "izvorni nivo kakav je bio na importu"
  },
  {
    name: "graphlevel",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    type: TYPE_INTEGER,
    size: 3,
    primer: 3,
    readme: "nivo prema teoriji grafova"
  },
  {
    name: "graphpath",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    type: TYPE_STRING,
    size: 300,
  },

  {
    name: "db_instance_flag_standalone",
    sect: SECT_DB,
    pods: {
      pods_meta: true,
    },
    ..._bool,
  },
  {
    name: "db_instance_flag_genus",
    sect: SECT_DB,
    pods: {
      pods_meta: true,
    },
    ..._bool,
  },
  {
    name: "db_join_with_genus",
    sect: SECT_DB,
    pods: {
      pods_meta: true,
    },
    ..._bool,
    readme: "flag da li ovu tabelu treba joinovati sa genus tabelom"
  },
  {
    name: "genus_ident",
    sect: SECT_DB,
    pods: {
      pods_meta: true,
    },
    type: TYPE_STRING,
    size: 24,
  },

  {
    name: "multitranslator_lang",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    type: TYPE_STRING,
    size: 300, // TODO ???
  },
  {
    name: "virtel_note",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    type: TYPE_STRING,
    size: 300, // TODO ???
  },


  // -----frontend, tracking itd.

  /*
  {
    name: "_draftelschemakey",
    sect: SECT_FRONTEND,
    pods: {
      pods_meta: true,
    },
    ..._string64,
    readme: "koristi se samo za draftele na frontendu",
  },
  */
  {
    name: "_tracking_key",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string64,
    readme: "sluzi da obelezi pojedini derivat u formulama na primer",
    primer: "derivat1_m"
  },


  // -----
  {
    name: "calculated_ident",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._string64,
    primer: "PM20DDA000005000",
  },
  {
    name: "identcustom",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "identmaterijala", // NOVO 2023-07-05
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },

  // ---QUANTITY
  {
    name: "kolicina",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
  },
  {
    name: "kolicina_za_nalog",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._float_mm,
  },
  {
    name: "jm",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 32,
  },

  //
  {
    name: "masa_po_jm",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_masa,
  },
  {
    name: "masa_po_jm_custom",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_masa,
  },
  {
    name: "flag_masa_po_jm_custom",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._bool,
  },
  {
    name: "masa_kumulativno",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._float_masa,
  },
  {
    name: "masa_po_jm_imported",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_masa,
  },

  //
  {
    name: "cena_po_jm",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_cena,
  },
  {
    name: "cena_po_jm_custom",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_cena,
  },
  {
    name: "flag_cena_po_jm_custom",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._bool,
  },
  {
    name: "cena_kumulativno",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._float_cena,
  },
  {
    name: "cena_po_jm_imported",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_cena,
  },


  // ---PARAMETRI ZA POPLUPROIZVODE I MATERIJALE
  {
    name: "operacija",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
    },
    ..._string64,
    primer: "OP-Secenje"
  },
  {
    name: "operacija1",
    sect: SECT_INSTANCE,
    pods: {
      pods_change: true,
    },
    ..._string64,
  },
  {
    name: "operacija2",
    sect: SECT_INSTANCE,
    pods: {
      pods_change: true,
    },
    ..._string64,
  },
  {
    name: "rc",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
    },
    ..._string64,
    primer: "RC-Sklapanje distr. elemenata"
  },
  {
    name: "rc1",
    sect: SECT_INSTANCE,
    pods: {
      pods_change: true,
    },
    ..._string64,
  },
  {
    name: "rc2",
    sect: SECT_INSTANCE,
    pods: {
      pods_change: true,
    },
    ..._string64,
  },
  {
    name: "angazovanihradnika",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
    },
    type: TYPE_INTEGER,
    size: 10,
  },
  {
    name: "vremepripreme",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
    },
    ..._vreme_minute,
  },
  {
    name: "vremeoperacije",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
    },
    ..._vreme_minute,
  },
  {
    name: "vremeugradnje",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
      pods_forward: true,
    },
    ..._vreme_minute,
  },
  {
    name: "vremeopsklapanje",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
      pods_der: true,
    },
    ..._vreme_minute,
  },
  {
    name: "vremekumulativno",
    sect: SECT_INSTANCE,
    pods: {
      pods_params: true,
      pods_change: true,
      pods_der: true,
    },
    ..._vreme_minute,
  },


  // -----TER

  {
    name: "terkategorija",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
    readme: "PP ili M ili OP. Proveriti jos da li ovo treba ili je to samo za satavnice i fixed fields"
  },
  {
    name: "tergrupa",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "teridentprefix",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
    readme: "Ako je definisan ovaj parametar onda se on zajedno sa Digest koristi za generisanje Ident-a"
  },
  {
    name: "tergrupacustom",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "virtelclass",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
    readme: ""
  },
  {
    name: "termaterijal",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
    readme: "ident materijala (lim, profil, platno) koji se trosi"
  },

  {
    name: "flag_custom_pods_input",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._bool,
  },

  {
    name: "naziv",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._string100,
  },
  {
    name: "tip",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string100,
  },
  {
    name: "pozicija",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string64,
    readme: "Ovo je univerzalno polje u sastavnicima, jos ga nismo koristili. "
  },
  {
    name: "cnccrtez",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 200
  },
  {
    name: "cncprogram1",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 200
  },
  {
    name: "cncprogram2",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 200
  },


  {
    name: "naziv_materijala", // NOVO PRIVREMENO
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 200
  },


  // -------Par1...par30------
  {
    ..._Par1_Par30,
    name: "Par1",
  },
  {
    ..._Par1_Par30,
    name: "Par2",
  },
  {
    ..._Par1_Par30,
    name: "Par3",
  },
  {
    ..._Par1_Par30,
    name: "Par4",
  },
  {
    ..._Par1_Par30,
    name: "Par5",
  },
  {
    ..._Par1_Par30,
    name: "Par6",
  },
  {
    ..._Par1_Par30,
    name: "Par7",
  },
  {
    ..._Par1_Par30,
    name: "Par8",
  },
  {
    ..._Par1_Par30,
    name: "Par9",
  },
  {
    ..._Par1_Par30,
    name: "Par10",
  },
  {
    ..._Par1_Par30,
    name: "Par11",
  },
  {
    ..._Par1_Par30,
    name: "Par12",
  },
  {
    ..._Par1_Par30,
    name: "Par13",
  },
  {
    ..._Par1_Par30,
    name: "Par14",
  },
  {
    ..._Par1_Par30,
    name: "Par15",
  },
  {
    ..._Par1_Par30,
    name: "Par16",
  },
  {
    ..._Par1_Par30,
    name: "Par17",
  },
  {
    ..._Par1_Par30,
    name: "Par18",
  },
  {
    ..._Par1_Par30,
    name: "Par19",
  },
  {
    ..._Par1_Par30,
    name: "Par20",
  },
  {
    ..._Par1_Par30,
    name: "Par21",
  },
  {
    ..._Par1_Par30,
    name: "Par22",
  },
  {
    ..._Par1_Par30,
    name: "Par23",
  },
  {
    ..._Par1_Par30,
    name: "Par24",
  },
  {
    ..._Par1_Par30,
    name: "Par25",
  },
  {
    ..._Par1_Par30,
    name: "Par26",
  },
  {
    ..._Par1_Par30,
    name: "Par27",
  },
  {
    ..._Par1_Par30,
    name: "Par28",
  },
  {
    ..._Par1_Par30,
    name: "Par29",
  },
  {
    ..._Par1_Par30,
    name: "Par30",
  },


  //


  {
    name: "tervrstaprofila_50_ili_70",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 2,
    readme: "'50' ili '70' koji se extractuje iz sonovnog profila"
  },


  // -------SPECIFICNI FILEDS------

  // terkk$klimakomora

  {
    name: "pozicijemodula",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string100,
  },
  {
    name: "sifrakomore",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string100,
  },
  {
    name: "nazivkomore",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string64,
  },
  {
    name: "nazivsistema",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string64,
  },
  {
    name: "tipkomore",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_UNKNOWN_,
    size: 100,
  },
  {
    name: "vrstaprofila",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "tipispuneklimakomore",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "unutrasnjaoplata",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },

  {
    name: "flag_dvevelicine",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._bool,
  },
  {
    name: "flag_dimenzijekomoreunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._bool,
  },
  {
    name: "flag_dimenzijekomore2unc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._bool,
  },

  {
    name: "_sirinakomoreoznaka",
    sect: SECT_FRONTEND
  },
  {
    name: "_visinakomoreoznaka",
    sect: SECT_FRONTEND,
  },
  {
    name: "_sirinakomore2oznaka",
    sect: SECT_FRONTEND
  },
  {
    name: "_visinakomore2oznaka",
    sect: SECT_FRONTEND,
  },
  {
    name: "_sirinakomoreunc",
    sect: SECT_FRONTEND
  },
  {
    name: "_visinakomoreunc",
    sect: SECT_FRONTEND,
  },
  {
    name: "_sirinakomore2unc",
    sect: SECT_FRONTEND
  },
  {
    name: "_visinakomore2unc",
    sect: SECT_FRONTEND,
  },

  {
    name: "sirinakomoreoznaka",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3
  },
  {
    name: "visinakomoreoznaka",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3
  },
  {
    name: "sirinakomoreunc",
    slaveof: "flag_dimenzijekomoreunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._integer_mm,
  },
  {
    name: "visinakomoreunc",
    slaveof: "flag_dimenzijekomoreunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._integer_mm,
  },
  {
    name: "sirinakomore2oznaka",
    slaveof: "flag_dvevelicine",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3
  },
  {
    name: "visinakomore2oznaka",
    slaveof: "flag_dvevelicine",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3
  },
  {
    name: "sirinakomore2unc",
    slaveof: "flag_dimenzijekomore2unc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3
  },
  {
    name: "visinakomore2unc",
    slaveof: "flag_dimenzijekomore2unc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._integer_mm,
  },

  // derivati
  {
    name: "ksirinaoznaka",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "ksirinaunutrasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirinaunutrasnjaizmedjupregradnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirinaunutrasnjaizmedjuosnovnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirinaunutrasnjaizmedjukrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirinaspoljasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
    readme: "odlucano 2021 AVGUST da se koriste spoljasnje"
  },

  {
    name: "ksirina2oznaka",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "ksirina2unutrasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirina2unutrasnjaizmedjupregradnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirina2unutrasnjaizmedjuosnovnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirina2unutrasnjaizmedjukrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "ksirina2spoljasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },

  {
    name: "kvisinaoznaka",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "kvisinaunutrasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisinaunutrasnjaizmedjupregradnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisinaunutrasnjaizmedjuosnovnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisinaunutrasnjaizmedjukrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisinaspoljasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
    readme: "odlucano 2021 AVGUST da se koriste spoljasnje"
  },

  {
    name: "kvisina2oznaka",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "kvisina2unutrasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisina2unutrasnjaizmedjupregradnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisina2unutrasnjaizmedjuosnovnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisina2unutrasnjaizmedjukrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "kvisina2spoljasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },


  // terkk$modul

  {
    name: "siframodula",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
      pods_der: true,
    },
    ..._string64,
  },
  {
    name: "brojmodula",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    type: TYPE_UNKNOWN_,
    size: 100
  },
  {
    name: "nazivmodula",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
    ..._string100,
  },

  {
    name: "flag_dimenzijemodulaunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._bool,
    readme: "FLAG PREKIDAC***"
  },
  {
    name: "_flag_dimenzijemodulaunc",
    sect: SECT_FRONTEND,
    ..._bool,
    readme: "SAMO ZA FORMU FLAG PREKIDAC***"
  },
  {
    name: "inputis_flag_dvevelicine",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._bool,
    readme: "KONTROLNA velicina da se vidi ukoliko je klimakomora editovana nakon unosa modula"
  },

  {
    name: "kojavelicina",
    // notslaveof: "flag_obedimenzijeunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 1
  },
  {
    name: "modul_vrsta_pakovanja",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 32
  },
  {
    name: "modul_vrsta_pakovanja_preporucena",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 32
  },
  {
    name: "sirinamodulaunc",
    slaveof: "flag_dimenzijemodulaunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._integer_mm,
  },
  {
    name: "visinamodulaunc",
    slaveof: "flag_dimenzijemodulaunc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._integer_mm,
  },

  {
    name: "duzinamodula",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._integer_mm,
  },

  // pregradni profili po standardnim dimenzijama
  {
    name: "brojkomadaprofilpregradnisirinski",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 5
  },
  {
    name: "brojkomadaprofilpregradnivisinski",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 5
  },

  // derivati
  {
    name: "msirinaunutrasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "msirinaunutrasnjaizmedjupregradnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "msirinaunutrasnjaizmedjuosnovnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "msirinaunutrasnjaizmedjukrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "mvisinaunutrasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "mvisinaunutrasnjaizmedjupregradnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "mvisinaunutrasnjaizmedjuosnovnih",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "mvisinaunutrasnjaizmedjukrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "msirinaspoljasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },
  {
    name: "mvisinaspoljasnja",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
    ..._integer_mm,
  },

  /*
  {
    name: "_arr_profilpregradniunc",
    sect: SECT_FRONTEND,
    readme: "nosac array-a samo za frontend"
  },
  */


  // ----- modul rogalj i modul profili

  // terkk$modul$rogalj
  {
    name: "vrstaprofila",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },


  // terkk$modul$profilosnovni

  {
    name: "vrstaprofila",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "sirinamodula",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "visinamodula",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "duzina",
    sect: SECT_GENUS,
    pods: {
      pods_der: true,
      pods_uni: true,
    },
    type: TYPE_FLOAT,
    // size: 6, // integer
    size: 6, // float
  },


  // terkk$modul$profil_materijal

  // terkk$modul$profilpregradni // ISTA POLJA IMA


  // terkk$materijalcustom


  // terkk$demper

  {
    name: "tipdempera",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "unutrasnjasirina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "unutrasnjavisina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "vrstapogona",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "osovina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "display_brojkrilaca",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
    },
  },

  {
    name: "unutrasnjasirina",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "brojkrilaca",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },

  {
    name: "unutrasnjasirina",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },


  // terkk$elasticnaveza

  {
    name: "prirubnica",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "platno",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "sirinaa",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "visinab",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "montiranjenademper",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },

  // terkk$eliminatorkapi

  {
    name: "tipeliminatorakapi",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "sirina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
      pods_uni: true,
    },
    type: TYPE_FLOAT,
    // size: 6, // integer
    size: 6, // float
  },
  {
    name: "visina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
      pods_uni: true,
    },
    type: TYPE_FLOAT,
    // size: 6, // integer
    size: 6, // float
  },
  {
    name: "debljina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
      pods_uni: true,
    },
    type: TYPE_FLOAT,
    // size: 6, // integer
    size: 6, // float
  },

  {
    name: "pbrojkomada",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },

  // terkk$spoljnafiksnazaluzina

  {
    name: "tipspoljnefiksnezaluzine",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "unutrasnjasirina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "unutrasnjavisina",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
  },

  /*
  {
    name: "unutrasnjasirina",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  */
  /*
  {
    name: "unutrasnjavisina",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  */


  //
  // terkk$panel

  {
    name: "sistempanela",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "tipunosapanela",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },

  {
    name: "tippanela",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string64,
  },
  {
    name: "panel_lim_spoljasnji_tip",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
  },
  {
    name: "panel_lim_unutrasnji_tip",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
  },

  {
    name: "_subform_arr",
    sect: SECT_FRONTEND,
    readme: "nosac array-a samo za frontend"
  },

  {
    name: "x1",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "y1",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "d1",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_FLOAT,
    size: 100,
  },
  {
    name: "x2",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "y2",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "d2",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_FLOAT,
    size: 100,
  },

  {
    name: "a",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "b",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "a2",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "b2",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },

  {
    name: "c",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "d",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "e",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "f",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },

  {
    name: "eliminatorkapi",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "smervazduha",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "kljuc",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "sigurnosnabrava",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3,
  },
  {
    name: "revizioniotvor",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3,
  },

  {
    name: "sistempanela",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "tipkomore",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
    ..._string64,
  },
  {
    name: "unutrasnjaoplata",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
    ..._string64,
  },
  {
    name: "tipispuneklimakomore",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
    ..._string64,
  },
  {
    name: "kljuc",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "sigurnosnabrava",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },

  {
    name: "sirinarazvijena",
    sect: SECT_GENUS,
    pods: {
      pods_der: true,
    },
  },
  {
    name: "leviger",
    sect: SECT_GENUS,
    pods: {
      pods_der: true,
    },
    ..._float_ugao,
  },
  {
    name: "desniger",
    sect: SECT_GENUS,
    pods: {
      pods_der: true,
    },
    type: TYPE_FLOAT,
    ..._float_ugao,
  },

  {
    name: "sistempanela",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "tipkomore",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "unutrasnjaoplata",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "tipispuneklimakomore",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "kljuc",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },
  {
    name: "sigurnosnabrava",
    sect: SECT_GENUS,
    pods: {
      pods_input: true,
    },
  },

  // KADICA

  {
    name: "odvodkondenzata",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_STRING,
    size: 3
  },

  // POSTOLJE
  {
    name: "smerojacanjapostolja",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string100,
  },
  {
    name: "sirinapostolja",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 3
  },
  {
    name: "duzinapostolja",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 3
  },
  {
    name: "visinapostolja",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 3
  },
  {
    name: "sirinaprofilapostolja",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 3
  },
  {
    name: "dimenzijazapozicije",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "dimenzija unutar koje se racunaju pozicija ojacanja"
  },
  {
    name: "pozicijaprofila",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "pozicija ojacanja u postolju"
  },
  {
    name: "pozicijaojacanja1",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaojacanja2",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaojacanja3",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaojacanja4",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaodvodakondenzata1",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaodvodakondenzata1",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaodvodakondenzata2",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },
  {
    name: "pozicijaodvodakondenzata3",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._float_mm,
    readme: "NOVO"
  },

  {
    name: "pozicijaojacanja_poduzini_pack",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string200,
    readme: "NOVO"
  },
  {
    name: "pozicijaojacanja_posirini_pack",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string200,
    readme: "NOVO"
  },
  {
    name: "pozicijaodvodakondenzata_pack",
    sect: SECT_INSTANCE,
    pods: {
      pods_own: true,
    },
    ..._string200,
    readme: "NOVO"
  },

  //


  {
    name: "povrsina",
    sect: SECT_INSTANCE,
    pods: {
      pods_der: true,
      pods_uni: true,
    },
    type: TYPE_FLOAT,
    // size: 6, // integer
    size: 6, // float
    readme: "povrsina materijala lim koja ide direktno u children materijal kolicinu"
  },

  // KROV
  {
    name: "tipkrovnogsegmenta",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    ..._string100,
  },
  {
    name: "x",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },
  {
    name: "y",
    sect: SECT_GENUS,
    pods: {
      pods_own: true,
    },
    type: TYPE_INTEGER,
    size: 6,
  },


  //

]; // end of virtel_field_schema_lib


export const virtel_field_schema_smart_get = (name) => {
  let bingo_field = {};
  let exit = false;
  let i = 0;
  while (exit === false) {
    if (virtel_field_schema_lib[i]) {
      if (typeof name === 'string' && virtel_field_schema_lib[i].name === name) {
        bingo_field = virtel_field_schema_lib[i];
        exit = true;
      }
      i++;
    } else {
      exit = true;
    }
  } // end of while
  /*
   virtel_field_schema_lib.forEach((f, index) => {
     if (f.name === name) {
       bingo_field = f;
     }
   });
   */
  return bingo_field;
};
